module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('a', {
    attrs: {
      "href": "#/08_Prologue#pro",
      "id": "pro"
    }
  }, [_c('em', [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Leon Fleisher")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('a', {
    attrs: {
      "href": "#/09_Foreword#for",
      "id": "for"
    }
  }, [_c('em', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_vm._v("Russell Sherman")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('a', {
    attrs: {
      "href": "#/10_Preface#pre",
      "id": "pre"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('a', {
    attrs: {
      "href": "#/11_Ack#ack",
      "id": "ack"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('a', {
    attrs: {
      "href": "#/12_Biographycal_sketch#Biographycal_sketch",
      "id": "Biographycal_sketch"
    }
  }, [_c('em', [_vm._v("Biographical Sketch")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "1.5em",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/13_Part1#part1",
      "id": "part1"
    }
  }, [_c('em', [_vm._v("Part I    COMPOSERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/14_Chapter1#ch1",
      "id": "ch1"
    }
  }, [_vm._v("Frescobaldi (1583–1643)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/15_Chapter2#ch2",
      "id": "ch2"
    }
  }, [_vm._v("Bach (1685–1750)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/15_Chapter2#ch2_1",
      "id": "ch2_1"
    }
  }, [_vm._v("His Last Work")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/15_Chapter2#ch2_2",
      "id": "ch2_2"
    }
  }, [_vm._v("Spirit, Style, and Forms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter3#ch3",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bach-Reger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter3#ch3_1",
      "id": "ch3_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brandenburg Concertos for Piano Duet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter4#ch4",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mozart (1756–1791)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter4#ch4_1",
      "id": "ch4_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quintet in D Major, K. 593")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter5#ch5",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beethoven (1770–1827)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter5#ch5_1",
      "id": "ch5_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Several Perspectives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter5#ch5_2",
      "id": "ch5_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mostly Beethoven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter5#ch5_3",
      "id": "ch5_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Beethoven’s Trills")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter5#ch5_4",
      "id": "ch5_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bagatelles, Op. 119")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/18_Chapter5#ch5_5",
      "id": "ch5_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ninth Symphony, Op. 125")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter6#ch6",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schubert (1797–1828)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter6#ch6_1",
      "id": "ch6_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schubert’s Reaction to Beethoven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter6#ch6_2",
      "id": "ch6_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schubert’s "), _c('em', [_vm._v("“L’istesso Tempo”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/19_Chapter6#ch6_3",
      "id": "ch6_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schubert’s String Quintet in C: A Misplaced Repeat Sign?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter7#ch7",
      "id": "ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Schumann (1810–1856)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/20_Chapter7#ch7_1",
      "id": "ch7_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Titles and Verbal Descriptions in Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter8#ch8",
      "id": "ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liszt (1811–1886)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter8#ch8_1",
      "id": "ch8_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beethovenian Dissonances in Liszt’s Piano Works")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Chapter8#ch8_2",
      "id": "ch8_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Liszt’s Approach to Piano Technique")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter9#ch9",
      "id": "ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stravinsky (1882–1971)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/22_Chapter9#ch9_1",
      "id": "ch9_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Modern Faust")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "1.5em",
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/23_Part2#part2",
      "id": "part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Part II    LETTERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_vm._v("From:")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1",
    staticStyle: {
      "text-indent": "-8em",
      "margin-left": "9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/24_Chapter10#ch10",
      "id": "ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul Badura-Skoda; Review of "), _c('em', [_vm._v("Interpretation on the Piano—What We Can Learn from Schnabel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/25_Chapter11#ch11",
      "id": "ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alfred Brendel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/26_Chapter12#ch12",
      "id": "ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul Henry Lang")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/27_Chapter13#ch13",
      "id": "ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rudolf Serkin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_vm._v("To:")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/28_Chapter14#ch14",
      "id": "ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leon Fleisher")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/29_Chapter15#ch15",
      "id": "ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Artur Schnabel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_vm._v("To and From:")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/30_Chapter16#ch16",
      "id": "ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Colleague")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/31_Chapter17#ch17",
      "id": "ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sviatoslav Richter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "1.5em",
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/32_Part3#part3",
      "id": "part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Part III    MISCELLANY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/33_Chapter18#ch18",
      "id": "ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/34_Chapter19#ch19",
      "id": "ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Music Appreciation 101")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/35_Chapter20#ch20",
      "id": "ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Authenticity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/36_Chapter21#ch21",
      "id": "ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beginnings of Cyclic Form")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/36_Chapter21#ch21_1",
      "id": "ch21_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bach’s Dedication to King Frederick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/37_Chapter22#ch22",
      "id": "ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("August Halm (1869–1929)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/38_Chapter23#ch23",
      "id": "ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Observations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/38_Chapter23#ch23_1",
      "id": "ch23_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Teaching")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/38_Chapter23#ch23_2",
      "id": "ch23_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On Music and Musicians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/39_Chapter24#ch24",
      "id": "ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Lesson in Writing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/40_Chapter25#ch25",
      "id": "ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johann Christian Bach (1735–1782): Siciliano in F-Sharp Minor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "1.5em",
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/41_Part4#part4",
      "id": "part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Part IV THE BRENDEL-WOLFF “DEBATE”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/42_Chapter26#ch26",
      "id": "ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The “Debate”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "0.5em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/43_Chapter27#ch27",
      "id": "ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Addendum by Alfred Brendel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/44_Notes#notes",
      "id": "notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/45_Bib#bib",
      "id": "bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0"
  }, [_c('span', {
    attrs: {
      "href": "#/46_Index#index",
      "id": "index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry0",
    staticStyle: {
      "padding-top": "1em"
    }
  }, [_c('em', [_vm._v("A photographic essay follows p. 120")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99f29920","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_Contents.vue
// module id = 78
// module chunks = 0